'use client'

import { Link } from '@/navigation'
import { Autoplay } from 'swiper'
import { useTranslations } from 'next-intl'
import { Swiper, SwiperSlide } from 'swiper/react'

import NewsCard from './NewsCard'

import type { FC } from 'react'
import type { IFetchedDataRoot, INewsData } from '@/types'

const News: FC<IFetchedDataRoot<INewsData>> = (data) => {
  const t = useTranslations()
  return (
    <section className="container mx-auto px-4 pt-[30px] md:pt-[100px]">
      <h2 className="mb-5 md:mb-10">{t('Routes.news')}</h2>
      <Swiper
        modules={[Autoplay]}
        autoplay
        breakpoints={{
          428: { slidesPerView: 1 },
          640: {
            slidesPerView: 2,
          },
          768: {
            slidesPerView: 2,
          },
          1024: {
            slidesPerView: 4,
          },
        }}
        spaceBetween={24}
        className="mb-5 md:mb-10"
      >
        {[...data.results]
          .sort((a, b) => new Date(b.published).getTime() - new Date(a.published).getTime())
          .slice(0, 4)
          .map((newsItemData, i) => (
          <SwiperSlide key={'news-card' + newsItemData.slug + i}>
            <NewsCard {...newsItemData} />
          </SwiperSlide>
        ))}
      </Swiper>
      <div className="flex justify-center">
        <Link href="/news" className="btn-primary" aria-label={t('Buttons.AllNews')}>
          {t('Buttons.AllNews')}
        </Link>
      </div>
    </section>
  )
}

export default News
